import script from "./LuoSqProductComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LuoSqProductComponent.vue?vue&type=script&setup=true&lang=js"

import "./LuoSqProductComponent.vue?vue&type=style&index=0&id=0f3abaee&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3abaee"]])

export default __exports__